import React, {useEffect, useState} from 'react'
import PageHeader from '../../../components/common/PageHeader'
import { getUserInfo } from '../../../utils/token';
import CustomerDynamicTable from '../../../components/common/CustomerDynamicTable';
import SubscriptionWidget from '../../../components/common/SubscriptionWidget';
import { getBatch } from '../../../api/endpoints/batch';
import { useNavigate } from 'react-router-dom';
import { showDeleteAlert } from '../../../utils/swalAlerts/showDeleteAlert';
import showSuccessAlert from '../../../utils/swalAlerts/showSuccessAlert';
import showErrorAlert from '../../../utils/swalAlerts/showErrorAlert';
import { cancelBatch } from '../../../api/endpoints/batch';

const BatchList = () => {
  const navigate = useNavigate();
  const [companyId, setCompanyId] = useState(null);
  const [customerId, setCustomerId] = useState([]);
  const [listData, setListData] = useState([]);


  const processStatus = ["Pending","In Progress","Completed","Cancelled" ];
  useEffect(()=>{
    async function fetchData() {
      const {compId, userId} = getUserInfo();
      setCompanyId(compId);
      setCustomerId(userId);
      await getBatch(compId, userId).then((res) => setListData(res.data.data));

    }
    fetchData();  
  },[]);

  const headerColumns = [
    
    { header: "Batch Title", accessor: "title"},
    { header: "Message Type", accessor: "msg_type"},
    { header: "Mobile", accessor: "device_mobile"},
    { header: "Total Records", accessor: "total_records"},
    { header: "Processed Records", accessor: "processed_records"},
    {
      header: "percentage",
      accessor: "processed_percentage",
      render: (value) => (
        <div class="progress progress-xl">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow={value} aria-valuemin="0" aria-valuemax="100" style={{width: value+'%'}}>{value}%</div>
        </div>
      ),
    },
    {
      header: "Status",
      accessor: "process_status",
      render: (value) => (
        <span className={`badge ${value === 2 ? "bg-success" : "bg-danger"}`}>
          {processStatus[value]}
        </span>
      ),
    },
  ];
  
  const handleView = (row) => {
    navigate('/customer/batch-details/'+row.batch_id);
    return false;
  }

  const handleCancel = (row) => {
    showDeleteAlert({
      title: 'Are you sure you want to cancel this batch',
      message: '',
      confirmButtonText: 'Yes, sure',
      isInfo: true,
      onConfirm: async () => {
        try {
          const response = await cancelBatch(row.batch_id);
          if(response.status === 200){
            // send sucess 
            //console.log(response.data);
            if(response.data.success){
              showSuccessAlert({
                title: "Batch Cancel Status",
                message: response.data.message,
                icon: "success",
                cancelText : 'Ok',
                onBack: () => window.location.reload(),
              })
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Cacnel failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  }

  return (
    <>
      <PageHeader  title="Batch List" breadcrumbs={[ {label: 'Customer'}, {label: 'Batch List'}]}/>
      <SubscriptionWidget 
          compId ={companyId}
          customerId = {customerId}
        />
        <CustomerDynamicTable 
          data={listData}
          columns={headerColumns}
          onView={handleView}
          onCancel={handleCancel}
        />
    </>
    
  )
}

export default BatchList